
import axios from 'axios';
import API from '@/common/API.js';
import router from '@/router/index.js';

const getUrlParams = function () {
    const params = {};
    window.location.search.replace(/[#?&]+([^=&]+)=([^&]*)/gi, function (str, key, value, ) {
        params[key] = value;
    });
    return params;
};

const ORIGIN_URL =
    getUrlParams().debug && getUrlParams().debug === '1' ?
    process.env.VUE_APP_API_URL_DEV :
    process.env.VUE_APP_API_URL_ORGIN;

export default ({

    actions: {

        postReview({commit}, payload){

            console.log("ORIGIN_URL" , `${ORIGIN_URL}/service/review`)
        
            return axios.post(`${ORIGIN_URL}/service/review`, payload, {}).then(res => {
                if(res.data.status===200 && res.data.message){
                    return res.data
                }else{
                    // throw 'postReview Api Res Error';
                }
            }).catch(err => {
                console.log('[[postReview]]', err);
                router.push({ name: 'Error' });
            });
        },

        postContents({commit}, payload){
            return axios.post(process.env.VUE_APP_URL_CONTENTS, payload, {}).then(res => {
                return res.data;
            }).catch(err => {
                console.log('[[postContents]]', err);
                return {status: 403};
            });
        },

        

        setImage({dispatch},payload){
            console.log("setImage");
            const headers = {
                'Content-Type': 'application/octet-stream'
            }
            return axios.post(`${API.URL.REVIEW}?id=${payload.id}&file=${payload.file}`, payload.data, {headers: headers}).then((res) => {
                return res
            }).catch(err => {
                console.log('setImage', err)
                alert('Please try again later.');
            })
        },
    },

})
